module.exports = __webpack_public_path__ + "img/title5.66edffb4.png";